import { Button, Modal } from "antd";
import "./Modal_No_Login.scss";
import { Link } from "react-router-dom";

function Modal_No_Login({ isModalOpen, handleCancel }) {
  return (
    <>
      <Modal
        centered
        width={500}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        mask={true}
        zIndex={2000}
      >
        <div className="modal">
          <div className="modal-img-logo">
            <img
              src="https://assets.depop.com/web/assets/images/depop-smile-sticker@2x.png"
              alt="Logo"
            />
          </div>

          <div className="modal-title-one">
            Bạn muốn tham gia để khám phá chứ?
          </div>
          <div className="modal-title-two">
            Hãy đăng ký hoặc đăng nhập để tiếp tục
          </div>

          <Link to="/register">
            <Button className="btn-sign-Up">Đăng kí</Button>
          </Link>

          <Link to="/login">
            <Button className="btn-sign-In">Đăng nhập</Button>
          </Link>

          <div class="divider">
            <span>Hoặc</span>
          </div>

          <div className="modal-img-qr">
            <img
              src="https://assets.depop.com/web/assets/get-the-app-qr-code.svg"
              alt="QR"
            />
          </div>

          <div className="modal-sub-one">Tải ứng dụng Depop miễn phí</div>
          <div className="modal-sub-two">Quét mã QR để tải xuống</div>
        </div>
      </Modal>
    </>
  );
}

export default Modal_No_Login;
